import React from 'react';
import Card from '../../../components/Card';
import Label from '../../../components/Label';
import { useBranding } from 'src/branding/BrandingContextProvider';
import { serviceRequestAgeEnum } from 'src/services/api/ServiceRequestDashboard/serviceRequestDashboard';
import { ServiceRequestFilters } from 'src/pages/ServiceRequests/CustomHooks/useServiceRequestFilters';
import { IDashboardAgeOverview } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './DaysSinceSubmissionCard.scss';

const label = (serviceRequestOverview) => [
  {
    color: 'red',
    label: '60+ days old',
    value: serviceRequestAgeEnum.olderThan60Days,
    count: serviceRequestOverview?.days60PlusCount ?? 0,
  },
  {
    color: 'yellow',
    label: '30-60 days old',
    value: serviceRequestAgeEnum.between30And60Days,
    count: serviceRequestOverview?.days30_60Count ?? 0,
  },
  {
    color: 'teal',
    label: '<30 days old',
    value: serviceRequestAgeEnum.daysLessThan30,
    count: serviceRequestOverview?.daysLessThan30 ?? 0,
  },
];

const toggleState = (state: any, newValue: any) =>
  state === newValue ? null : newValue;

interface DaysSinceSubmissionCardProps {
  serviceRequestOverview: IDashboardAgeOverview;
  loading?: boolean;
  filters: ServiceRequestFilters;
  applyFilter: (key: string, data: any) => void;
}

const DaysSinceSubmissionCard = ({
  serviceRequestOverview,
  loading = false,
  filters,
  applyFilter,
}: DaysSinceSubmissionCardProps) => {
  const { branding, isBranded } = useBranding();
  const { selectedDate } = filters;

  const onSelectDate = (date) => {
    applyFilter('selectedDate', toggleState(selectedDate, date));
  };

  return (
    <div className="daysSinceSubmissionCard">
      <Card
        title="Days Since Submission"
        body={
          <div className="submissionGrid">
            {label(serviceRequestOverview).map((labelItem, index) => (
              <div
                key={index}
                className={`submissionItem compact ${
                  selectedDate === labelItem.value ? 'selected' : ''
                }`}
                onClick={() => onSelectDate(labelItem.value)}
              >
                <div className="submissionContent">
                  <Label color={labelItem.color} label={labelItem.label} />
                </div>
                <div
                  className="submissionCount"
                  style={{
                    color: isBranded
                      ? branding.colours.text.emphasis
                      : undefined,
                  }}
                >
                  {loading ? (
                    <Skeleton variant="text" width="2.4rem" />
                  ) : (
                    labelItem.count
                  )}
                </div>
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
};

export default DaysSinceSubmissionCard;
